import { render } from "./TelasBanner.vue?vue&type=template&id=6de3701d&lang=pug"
import script from "./TelasBanner.vue?vue&type=script&lang=js"
export * from "./TelasBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__